import { styled, Theme } from '@mui/material';

export const PhasePositionMarker = styled('div')<{ theme: Theme; $ratio: number; $color: string }>(
    ({ $ratio, $color }) => ({
        width: 1,
        position: 'absolute',
        height: '100%',
        background: $color,
        opacity: 0.5,
        top: 0,
        left: `${$ratio * 100}%`,
    }),
);

export const ResultsInsightsFrameLink = styled('a')(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    cursor: 'pointer',
}));

export const ResultsInsightsRow = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));
